import DataMigrationSegment from 'src/models/data-migration/DataMigrationSegment'
import Model, { ID, Integer, IsoDateTime } from 'src/models/model'

export default class DataMigration extends Model {
  static name = 'DataMigration'

  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Data]

  static define () {
    this.fields = {
      id: {
        type: ID,
        output: true
      },
      state: {
        type: String,
        output: true
      },
      migrator: {
        type: String,
        output: true
      },
      dataMigrationSegments: {
        type: [DataMigrationSegment],
        output: true
      },
      percentCompleteHundredths: {
        type: Integer,
        output: true
      },
      estimatedTimeRemainingSeconds: {
        type: Integer,
        output: true
      },
      startedAt: {
        type: IsoDateTime,
        output: true
      },
      completedAt: {
        type: IsoDateTime,
        output: true
      }
    }
  }

  get estimatedTimeRemaining () {
    if (!this.estimatedTimeRemainingSeconds) return null

    return new IsoDateTime(Date.now() + this.estimatedTimeRemainingSeconds * 1000)
  }
}
